import { usePathname } from 'next/navigation';
import { ReactNode } from 'react';

import { LinkWithChevron } from '@/components/Link/LinkWithChevron';

import { ErrorLayout } from './ErrorLayout';
import styles from './ErrorNotFound.module.scss';

type Props = {
	topArticles: ReactNode;
};

export function ErrorNotFound({ topArticles }: Props) {
	const pathname = usePathname();

	const isHomePage = pathname === '/';

	return (
		<ErrorLayout>
			<div className={`heading1 ${styles.titlePrimary}`}>Fehler 404 – Seite nicht verfügbar</div>

			<section className={`body1 ${styles.section}`}>
				<p>An was kann das liegen?</p>

				<ul className={styles.unorderedList}>
					<li>Die Seite gibt es nicht mehr.</li>
					<li>Es liegt ein Tippfehler in der Adresse vor.</li>
				</ul>
				<ul className={styles.list}>
					<li className={styles.listItem}>
						Um den gewünschten Inhalt zu finden, überprüfen Sie, ob die URL korrekt ist oder nutzen Sie die Suche oben rechts.
					</li>

					{!isHomePage && (
						<li className={styles.listItem}>
							<LinkWithChevron href="/">
								<span className="heading3">Zur BR24 Startseite</span>
							</LinkWithChevron>
						</li>
					)}
				</ul>
			</section>

			<section className={styles.section}>{!!topArticles && topArticles}</section>
		</ErrorLayout>
	);
}
